// extracted by mini-css-extract-plugin
module.exports = {"options":"lGpEBh","label":"m5p5rz","categoryPage":"JrgsPG","labelText":"IoYk6Z","checkbox":"m0NlxI"};